// NCXPrivacyPolicyCompact.jsx
import React from "react";
import DOMPurify from "dompurify";
import { s360ConfigService } from "../../../Services/S360Config";
import { DATA_TEST_ID_PREFIX, LIVECHAT_CLICK_EVENTS } from "../../../../utils/Constants/statsig.constants";

export default function NCXPrivacyPolicyCompact({ config, onAccept }) {
  if (!config?.enabled) return null;

  return (
    <div
      className="ncx-privacy-policy-compact"
      style={{
        backgroundColor: config.backgroundColor || "#f5f7fa",
        padding: "12px 16px",
        boxShadow: "0 1px 8px rgba(0,0,0,0.08)",
        fontFamily: "Arial, sans-serif",
        maxWidth: "100%",
        margin: "0 auto",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        fontSize: "xx-small",
      }}
    >
      <div style={{ flex: 1, paddingRight: "12px" }}>
        <div
          style={{
            fontSize: "13px",
            color: "#333",
            lineHeight: "1.4",
            marginBottom: config.url ? "8px" : "0",
          }}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(config.text),
          }}
        />
        {config.url && (
          <div style={{ marginTop: "-8px" }}>
            <a
              href={config.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#007bff",

                fontSize: "13px",
              }}
            >
              See our Privacy Policy
            </a>
          </div>
        )}
      </div>
      <div>
        <svg
          style={{ cursor: "pointer" }}
          onClick={s360ConfigService.config.sandBox ? undefined : onAccept}
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          data-testid={`${DATA_TEST_ID_PREFIX}-${LIVECHAT_CLICK_EVENTS.PRIVACY_POLICY_CLICKED}`}
        >
          <path
            d="M10.7812 2.28125L7.03125 6.03125L10.75 9.75C11.0625 10.0312 11.0625 10.5 10.75 10.7812C10.4688 11.0938 10 11.0938 9.71875 10.7812L5.96875 7.0625L2.25 10.7812C1.96875 11.0938 1.5 11.0938 1.21875 10.7812C0.90625 10.5 0.90625 10.0312 1.21875 9.71875L4.9375 6L1.21875 2.28125C0.90625 2 0.90625 1.53125 1.21875 1.21875C1.5 0.9375 1.96875 0.9375 2.28125 1.21875L6 4.96875L9.71875 1.25C10 0.9375 10.4688 0.9375 10.7812 1.25C11.0625 1.53125 11.0625 2 10.7812 2.28125Z"
            fill="#616576"
          />
        </svg>
      </div>
    </div>
  );
}
